"use strict";

export function initInScope($scope) {
    let $toggleActive = $scope.find('.js-toggle-active');

   $toggleActive.on('click', function() {
      $(this).toggleClass('active');
   })
}